import React from 'react';

import { cn } from '@/lib/utils';

export interface MetricCardGroupProps {
  children: React.ReactNode;
  className?: string;
}

export function MetricCardGroup({ children, className }: MetricCardGroupProps) {
  return (
    <div className={cn('flex flex-wrap', className)}>
      {React.Children.map(children, (child, index) => (
        <div key={index} className="flex items-stretch first:pl-0">
          {child}
        </div>
      ))}
    </div>
  );
}
